import axios, { AxiosResponse, AxiosInstance } from 'axios'
import { message } from 'ant-design-vue'
import { ACCESS_TOKEN, USER_INFO } from '@/store/mutation-types'
import ls from '@/utils/Storage'
import { globalLoading } from '@/store/reactiveState'
import emitter from '@/utils/eventBus'
import { clearUserInfo } from '@/utils/util'

export let isRedirecting = false

export function triggerRedirect() {
  if (!isRedirecting) {
    isRedirecting = true
    clearUserInfo()
    setTimeout(() => {
      window.location.href = '/login'
    }, 1500)
  }
}

// 创建 axios 实例   withCredentials: true,
const baseService = axios.create({
  baseURL: import.meta.env.VITE_PROXY,
  timeout: 50000,
  headers: { 'Content-Type': 'application/json' }
})

// request interceptor
baseService.interceptors.request.use(
  (config) => {
    globalLoading.value = true
    if (isRedirecting) {
      return Promise.reject(new axios.Cancel('redirect_in_progress'))
    }
    const token = ls.get(ACCESS_TOKEN)
    const userinfo = ls.get(USER_INFO)
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },
  (error) => {
    globalLoading.value = false
    return Promise.reject(error)
  }
)

baseService.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    globalLoading.value = false
    if (isRedirecting) {
      return Promise.reject(new axios.Cancel('redirect_in_progress'))
    }
    const res = response.data
    if (res.code && res.code !== 200) {
      if (res.code == 401 || (res.code == 405 && response.config.url == '/console/auth/pcLoginStepTwo') || response.config.url == '/console/auth/info') {
        triggerRedirect()
        return Promise.reject(res)
      }
      message.error(res.msg)
      return Promise.reject(res)
    }
    return res
  },
  (error) => {
    globalLoading.value = false
    if (isRedirecting || axios.isCancel(error)) {
      return Promise.reject(error)
    }
    const msg = error.message
    const result = error.response
    if (result) {
      const { data, status } = result
      if (data.message) {
        message.error(data.message)
      } else if (status === 401 || status === 403) {
        triggerRedirect()
      } else if (status === 500) {
        message.error('请求数据失败, 请重试!')
      }
    } else if (msg) {
      if (msg === 'Network Error') {
        message.error('网络错误,请检查网络!')
      } else {
        message.error(msg)
      }
    } else if (error.__CANCEL__) {
      // ignore
    } else {
      message.error('未知错误,请重试!')
    }
    return Promise.reject(error)
  }
)

export default baseService
